import SubunitsApi from '../../apis/Subunits';

export default {
    namespaced: true,
    state: {
        subunits: []
    },
    mutations: {
        set_subunits (state, data) {
            state.subunits = data;
        }
    },
    actions: {
        async getAllSubunits ({commit}, filters) {
            return await SubunitsApi.get_all(filters)
                        .then( response => {
                            commit('set_subunits', response.data)
                        })
                        .catch( error => {
                            console.log(error);
                        })
        }
    }
}